<template>

    <div>
        <v-modal-section :title="$t('titles.mcp_server')" icon="fas fa-robot">
            <v-form-group :caption="$t('captions.mcp_server_url')">
                <v-copy-box>{{ project.mcp_server_scoped_url }}</v-copy-box>
            </v-form-group>
        </v-modal-section>
        <v-modal-section :title="$t('titles.example_chat')" icon="fas fa-comment-dots">
            <div class="mcp-thread">
                <div class="mcp-msg mcp-msg-user">
                    <div class="mcp-msg-label">{{ $t('labels.you') }}</div>
                    <div class="mcp-msg-bubble">{{ prompt }}</div>
                </div>
                <div class="mcp-msg mcp-msg-assistant">
                    <div class="mcp-msg-label">{{ $t('labels.ai_assistant') }}</div>
                    <div class="mcp-msg-bubble">{{ reply }}</div>
                </div>
            </div>
        </v-modal-section>
    </div>

</template>

<style scoped lang="scss">

    .mcp-thread {
        background: $color-bg;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 15px;
        padding: 15px;
    }

    .mcp-msg {
        display: flex;
        flex-direction: column;
        max-width: 90%;
        width: fit-content;
    }

    .mcp-msg-label {
        @include font-medium(13px);
        color: $color-text;
        margin-bottom: 5px;
    }

    .mcp-msg-bubble {
        @include font-regular(13px);
        display: inline-block;
        line-height: 1.4em;
        padding: 12px 15px;
        text-align: left;
        white-space: pre-wrap;
        word-break: break-word;
    }

    .mcp-msg-user {
        align-items: flex-end;
        align-self: flex-end;
        .mcp-msg-label {
            text-align: right;
        }
        .mcp-msg-bubble {
            background: $color-text;
            border: 1px solid $color-white;
            border-radius: 16px 4px 16px 16px;
            color: $color-white;
        }
    }

    .mcp-msg-assistant {
        align-items: flex-start;
        align-self: flex-start;
        .mcp-msg-bubble {
            background: $color-white;
            border: 1px solid $color-rule;
            border-radius: 4px 16px 16px 16px;
            color: $color-text;
        }
    }

</style>

<script>

import CopyBox from '@cmp/CopyBox';
import ModalSection from '@cmp/ModalSection';

export default {

    components: {
        'v-copy-box': CopyBox,
        'v-modal-section': ModalSection,
    },

    props: {
        context: {
            type: String,
            required: true,
            validator(value) {
                return ['customer', 'review'].includes(value);
            },
        },
    },

    computed: {

        exampleParams() {
            return {
                email: this.user.email,
                name: this.user.name || this.user.first_name,
            };
        },

        prompt() {
            return this.$t('mcp_example_prompts.texts.import_' + this.context, this.exampleParams);
        },

        reply() {
            return this.$t('mcp_example_prompts.texts.import_' + this.context + '_reply', this.exampleParams);
        },

    },

}

</script>
